<template>
    <div>
        <b-button-group class="mt-2 mb-2 full-width">
            <b-button @click="downloadInterpretations()" title="Download interpretations in a CSV file"><b-icon
                    icon="download" class="mr-1"></b-icon>Export</b-button>
        </b-button-group>
        <div class="accordion" role="tablist">
            <b-card no-body class="mb-1" v-for="interpretation of interpretations" :key="interpretation.run_infos.id">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle :href="'#interpretation_accordion-' + interpretation.run_infos.id"
                        :variant="interpretation.selected ? 'info' : ''">{{
                            interpretation.run_infos.machine_name + " - " + interpretation.run_infos.ananke_id +
                            (interpretation.selected ? " (Selected)" : " (Unselected)")
                        }}</b-button>
                </b-card-header>
                <b-collapse :id="'interpretation_accordion-' + interpretation.run_infos.id"
                    :visible="interpretation.run_infos.id == interpretations[0].run_infos.id"
                    accordion="interpretation-accordion" role="tabpanel">
                    <b-card-body>
                        <b-list-group v-if="interpretation.results">
                            <b-list-group-item v-for="result of interpretation.results" :key="result.name"><strong>{{
                                result.name }}: </strong>{{ result.values.join(", ") }}</b-list-group-item>
                        </b-list-group>
                        <b-list-group v-else>
                            <b-list-group-item
                                v-if="interpretation.valid_internal_control !== undefined"><strong>Internal Control
                                    Validity: </strong>{{
                                        interpretation.valid_internal_control ? 'Valid' : 'Invalid' }}</b-list-group-item>
                            <b-list-group-item v-for="result_index in interpretation.compute_results.length"
                                :key="result_index">
                                <strong>{{ getTranslated(interpretation.compute_results[result_index - 1].label)
                                    }}: </strong>
                                <span v-if="interpretation.compute_results[result_index - 1].value">
                                    <span v-if="interpretation.compute_results[result_index - 1].format == 'float'">{{
                                        interpretation.compute_results[result_index - 1].value.toExponential(2)
                                    }}</span>
                                    <span
                                        v-else-if="interpretation.compute_results[result_index - 1].format == 'int'">{{
                                            Math.round(interpretation.compute_results[result_index - 1].value * 100) / 100
                                        }}</span>
                                    <span v-else>{{
                                        interpretation.compute_results[result_index - 1].value }}</span>
                                </span>
                                <span v-else>N/A</span>
                                <span>{{ getTranslated(interpretation.compute_results[result_index - 1].unit) }}</span>
                            </b-list-group-item>
                        </b-list-group>
                    </b-card-body>
                </b-collapse>
            </b-card>
        </div>
    </div>
</template>

<script>
import { translate } from "../../utils/translate"

export default {
    name: "InterpretationTable",
    props: [
        "interpretations",
        "analysis_version"
    ],
    methods: {
        getTranslated(key) {
            return translate(key)
        },
        downloadInterpretations() {
            var column_names = [
                "Machine Name",
                "Chronos ID",
                "Description",
                "Samples",
                "Chip barcode",
                "Batch ID",
                "Analysis version",
                "Analysis date (UTC)"
            ];
            for (let interpretation of this.interpretations) {
                if (interpretation.results) {
                    for (let result of interpretation.results) {
                        if (!column_names.includes(result.name)) {
                            column_names.push(result.name)
                        }
                    }
                }
                else {
                    var column_name = "Internal Control Validity"
                    if (!column_names.includes(column_name)) {
                        column_names.push(column_name)
                    }
                    for (let result_index = 0; result_index < interpretation.compute_results.length; result_index++) {
                        column_name = this.getTranslated(interpretation.compute_results[result_index].label) +
                            " (" + this.getTranslated(interpretation.compute_results[result_index].unit).trim() + ")"
                        if (!column_names.includes(column_name)) {
                            column_names.push(column_name)
                        }
                    }
                }
            }
            var rows = []
            for (let interpretation of this.interpretations) {
                let row = [
                    interpretation.run_infos.machine_name,
                    interpretation.run_infos.ananke_id,
                    interpretation.run_infos.description,
                    interpretation.run_infos.samples,
                    interpretation.run_infos.chip_barcode,
                    interpretation.run_infos.batch_range,
                    this.analysis_version,
                    interpretation.date
                ]
                if (column_names.length > 7) {
                    for (let column_index = 8; column_index < column_names.length; column_index++) {
                        var result = undefined
                        if (interpretation.results) {
                            result = interpretation.results.find(ele => ele.name == column_names[column_index])?.values
                            if (result) {
                                result = result.join(",")
                            }
                        }
                        else {
                            result = interpretation.compute_results.find(ele => this.getTranslated(ele.label) +
                                " (" + this.getTranslated(ele.unit).trim() + ")" == column_names[column_index])?.value
                        }
                        if (result) {
                            row.push(result)
                        } else {
                            row.push(null)
                        }
                    }
                }
                rows.push(row)
            }
            const array_data = [column_names].concat(rows);
            const csv_content =
                '"' + array_data.map((ele) => ele.join('","')).join('"\n"') + '"';
            const encoded_uri =
                encodeURI("data:text/csv;charset=utf-8,") +
                encodeURIComponent(csv_content);
            const link = document.createElement("a");
            link.setAttribute("href", encoded_uri);
            const now = new Date();
            const fileName =
                "gaia_data_interpretation_" + this.analysis_version + "_" +
                now.getFullYear() +
                (now.getMonth() + 1) +
                now.getDate() +
                "T" +
                now.getHours() +
                now.getMinutes() +
                now.getSeconds() +
                ".csv";
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
        }
    }
}
</script>
<style scoped>
.full-width {
    width: 100%
}
</style>